import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import List from "../common/List";
import ProductListItem from '../common/ProductListItem';

class ArchiveCategory extends Component{
	/**
	 * Render one product item
	 *
	 * @param product - one product to be rendered
	 * @returns {XML}
	 */
	renderProductList = (product) => {
		const {localizePath} = this.props;
		return (
			<ProductListItem
				key={product.id}
				product={product}
				localizePath={localizePath}/>
		);
	};

	render(){
		const {type, filteredProducts, rendered} = this.props;
		if( rendered === 'ALL' || rendered === type.name ){
			return(
				<div>
					<h2><FormattedMessage id={"archive.type." + type.name}/></h2>
					<List className="product-list" items={filteredProducts.map(this.renderProductList)}/>
				</div>
			);
		}
		return null;
	};
}

export default ArchiveCategory;


// WEBPACK FOOTER //
// ./src/components/common/ArchiveCategory.js